<template>
  <footer>
    <div class="cont left">
      <img
        src="../../assets/images/gyra_banner/gyra_banner@3x.png"
        alt="Gyra Banner"
        class="gyra_banner"
      />
      <p>{{ "footer.titles.copyright" | translate }}</p>
      <p class="version">version {{ require("../../../package").version }}</p>
    </div>
    <div class="cont middle">
      <h3>{{ "footer.titles.join_us" | translate | uppercase }}</h3>
      <div class="for">
        <p @click="visitAboutUs">
          {{ "footer.titles.about_us" | translate }}
        </p>
        <p class="wide" @click="visitForBusiness">
          {{ "footer.titles.for_business" | translate }}
        </p>
        <p @click="visitJobs" class="hidden">
          {{ "footer.titles.jobs" | translate }}
        </p>
      </div>
    </div>
    <div class="cont right">
      <h3>{{ "footer.titles.contact" | translate | uppercase }}</h3>
      <p>{{ "footer.titles.email" | translate }}</p>
      <div class="socials">
        <a
          class="social-link"
          href="https://www.instagram.com/gyra.shop/"
          target="_blank"
        >
          <img
            src="../../assets/images/social/instagram.png"
            alt="instagram"
            class="social"
          /> </a
        ><a
          class="social-link"
          href="https://www.linkedin.com/company/gyraofficial"
          target="_blank"
        >
          <img
            src="../../assets/images/social/linkedin.png"
            alt="linkedin"
            class="social"
          />
        </a>
      </div>
      <a
        class="cursor"
        href="https://docs.google.com/document/d/e/2PACX-1vQZHpRJyTggjZPwZQW_sw2FIbpsv20qMacrgoFXWhSlqhjCDIxMFqJGMD2ImQKVkGLNDLYcEEyRSpqO/pub"
        download="gyra_privacy_policy.pdf"
      >
        {{ "footer.titles.privacy_policy" | translate }}
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "the-footer",
  methods: {
    visitStoreInfo() {
      this.$router.push({ name: "StoresInfo" });
    },
    visitAboutUs() {
      this.$router.push({ name: "AboutPage" });
    },
    visitForBusiness() {
      this.$router.push({ name: "ForBusinessPage" });
    },
    visitJobs() {
      this.$router.push({ name: "JobPage" });
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
footer {
  overflow-x: hidden;
  min-height: $gyra-footer-min-height;
  background-color: $gyra-grey-lightest;
  display: flex;
  padding: 0 50px;
  flex-direction: column;
  justify-content: space-between;
  @media (min-width: 1200px) {
    flex-direction: row;
  }
}
p,
h3,
a {
  color: $gyra-grey-dark;
  font-size: 20px;
  margin: 10px 0;
}
h3 {
  font-weight: bold;
}
.hidden {
  display: none !important;
}
.cont {
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 70px;
}
.socials {
  display: flex;
  flex-direction: row;
}
.social-link {
  margin-right: 10px;
}
.cursor {
  cursor: pointer;
}

.gyra_banner {
  width: 164px;
  height: 58px;
}

.left {
  p {
    font-size: 20px;
  }
}
.wide {
  width: 70%;
}
p {
  margin-bottom: 0;
}
.for {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  p,
  a {
    width: 80%;
    @media (min-width: 680px) {
      width: 50%;
    }
    cursor: pointer;
    text-decoration: none;
  }
}
.version {
  font-size: 12px !important;
  margin-top: 0;
}
.middle {
  width: 350px;
}
.social {
  height: 30px;
  width: 30px;
  background-position: center;
  color: $gyra-grey-dark;
  cursor: pointer;
}
</style>
